<template>
<div>
  <Header @tabFlag="chooseLeft"/>
  <el-container>
    <financeLeft @tabFlag="chooseLeft" />
    <div class="app-wrap">
      <!-- 此处放置el-tabs代码 -->
      <div class="template-tabs">
        <el-tabs
          v-model="activeIndex"
          type="card"
          @tab-click="tabClick"
          v-if="options.length && (noCurrentTab.indexOf(options[0].parent) == -1)"
          @tab-remove="tabRemove">
          <el-tab-pane
            v-for="(item,index) in options"
            :key="item.route.split('/')[2]+index"
            :closable="!item.parent"
            :label="item.name"
            :name="item.route.split('/')[2]">
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="content-wrap">
        <router-view/>
      </div>
    </div>
  </el-container>
</div>
</template>
<script type="text/javascript">
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
import financeLeft from "@/components/common/financeLeft.vue";

export default {
  components: {
    Header,
    financeLeft,
    Footer
  },
  data() {
    return {
      noCurrentTab:['royaltyTeamSum','royaltyPersonSum','manualcostForm','todoorForm','order','serviceList','returnList','inventory','memRecharge','cashConcession','staffSale','sfaffService','cashFlow','manualcostForm','memServiceForm','returnMoneyList','returnRechargeList','summaryDetail','accountStatiste'],
      tabFlag:false,
    };
  },

  methods: {
    // tab切换时，动态的切换路由
    tabClick(tab) {
      let path = this.activeIndex;
      this.$router.push({ path: path });
      this.tabFlag = true;
    },
    tabRemove(targetName) {
      // 固定下级标签不可删除
      for(let i of this.options){
        if(!i.parent && targetName == i.route.split('/')[2]){
          this.$store.commit("delete_tabs", '/financeManageCenter/'+targetName);
          if (this.activeIndex === targetName) {
            // 设置当前激活的路由
            if (this.options && this.options.length >= 1) {
              this.$store.commit(
                "set_active_index",
                this.options[this.options.length - 1].route
              );
              this.$router.push({ path: this.activeIndex });
            }
          }
        }
      }
    },
    chooseLeft(val){
      this.tabFlag = val;
    }
  },
  computed: {
    options() {
      return this.$store.state.options;
    },
    activeIndex: {
      get() {
        return this.$store.state.activeIndex;
      },
      set(val) {
        this.$store.commit("set_active_index", val);
      }
    }
  },
  activated() {
    let curName = this.$route.path.split("/")[2],
      parentName = this.$route.meta.parent;
    let myAllroute = this.$router.options.routes[14];
    if (parentName === curName) {
      this.$store.state.options = [];
      if(myAllroute){
        myAllroute.children.forEach((i,index)=>{
          if(curName === i.meta.parent){
            this.$store.state.options.push({
              route:i.path,
              name:i.name,
              parent:i.meta.parent
            })
          }else{
            return;
          }
        })
      }
    }
  },
  watch: {
    $route(to) {
      let flag = false;
      let curName = to.path.split("/")[2], parentName = to.meta.parent;
      let myAllroute = this.$router.options.routes[14];
      if(!this.tabFlag){
        if (parentName === curName) {
          this.$store.state.options = [];
          if(myAllroute){
            myAllroute.children.forEach((i,index)=>{
              if(curName === i.meta.parent){
                this.$store.state.options.push({
                  route:i.path,
                  name:i.name,
                  parent:i.meta.parent
                })
              }else{
                return;
              }
            })
          }
        }
      }
      for (let option of this.options) {
        if (option.name === to.name) {
          flag = true;
          this.$store.commit("set_active_index", curName);
          break;
        }
      }
      if (!flag &&　to.path.split('/')[1] == 'financeManageCenter') {
        this.$store.commit("add_tabs", { route: to.path, name: to.name });
        this.$store.commit("set_active_index", curName);
      }
      if (JSON.stringify(this.options).indexOf(to.path) == -1 &&　to.path.split('/')[1] == 'financeManageCenter') {
				this.$store.commit('add_tabs', {route: to.path , name: to.name });
			}
    }
  },
};
</script>
<style lang="less">
@import "../../assets/css/tab.css";
</style>



// WEBPACK FOOTER //
// src/components/businessManagementCenter/financeManageCenter.vue